import React, { Component } from 'react';

import IQVIALogo from '../../../assets/images/IQVIA.svg';

export default class LoginHeaderImage extends Component {
  render() {
    return (
      <div className="login-header">
        <img src={IQVIALogo} alt="IQVIA logo" width={137} height={25} />
      </div>
    );
  }
}
